import defaultSettings from '@/settings'

const {
  title,
  appName,
  appVersion,
  appDescription,
  host,
  baseURL,
  listPath,
  bannerPath,
  spuPath,
  skuPath,
  logoPath,
  photoPath,
  avatarsPath,
  sitePath,
  qrPath,
  tempPath,
  apiPlanePath,
  apiAdminPath,
  apiGodPath,
  apiPayPath,
  apiLoginPath,
  apiAppPath,
  qweatherHost,
  qweatherApiKey,
  weatherCacheMinutes,
  mqttHost,
  mqttPort
} = defaultSettings

const state = {
  title: title,
  appName: appName,
  appVersion: appVersion,
  appDescription: appDescription,
  host: host,
  baseURL: baseURL,
  listPath: listPath,
  bannerPath: bannerPath,
  spuPath: spuPath,
  skuPath: skuPath,
  logoPath: logoPath,
  photoPath: photoPath,
  avatarsPath: avatarsPath,
  sitePath: sitePath,
  qrPath: qrPath,
  tempPath: tempPath,
  apiPlanePath: apiPlanePath,
  apiAdminPath: apiAdminPath,
  apiGodPath: apiGodPath,
  apiPayPath: apiPayPath,
  apiLoginPath: apiLoginPath,
  apiAppPath: apiAppPath,
  qweatherHost: qweatherHost,
  qweatherApiKey: qweatherApiKey,
  weatherCacheMinutes: weatherCacheMinutes,
  mqttHost: mqttHost,
  mqttPort: mqttPort
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
